import { render } from "./ConstructionView.vue?vue&type=template&id=454f2172&scoped=true"
import script from "./ConstructionView.vue?vue&type=script&lang=js"
export * from "./ConstructionView.vue?vue&type=script&lang=js"

import "./ConstructionView.vue?vue&type=style&index=0&id=454f2172&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454f2172"]])

export default __exports__